import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class SimilarProductModal extends PureComponent {
  render() {
    const { productName, modalAction } = this.props;
    return (
      <div>
        <Dialog
          open={Boolean(productName)}
          onClose={modalAction('close')}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{''}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {`You are currently connected to "${productName}" . Do you want to Disable ${productName} Integration ?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={modalAction('yes')}
              color="primary"
              className="confirm-btn"
            >
              Yes
            </Button>
            <Button onClick={modalAction('no')} color="primary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
